import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=7462b796&scoped=true&"
import script from "./Policies.vue?vue&type=script&lang=ts&"
export * from "./Policies.vue?vue&type=script&lang=ts&"
import style0 from "./Policies.vue?vue&type=style&index=0&id=7462b796&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7462b796",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VProgressCircular,VTab,VTabs})
